// extracted by mini-css-extract-plugin
export default {"tag":"AnnotationTag_tag__bGFZV","tag__selected":"AnnotationTag_tag__selected__5wVgb"};